import * as types from './actionTypes';

export const setMode = mode => ({
    type:types.SetMode,
    mode
});

export const setPreviewResolution = previewResolution => ({
    type: types.SetResolution,
    previewResolution
});

